window.FichaFinanceira = Backbone.Model.extend({

});

window.FichasFinanceira = Backbone.Collection.extend({
    model: FichaFinanceira
});